var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerticalLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1,
  height: 34,
  viewBox: "0 0 1 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 34,
  fill: "#E9EEF2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerticalLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vertical-line.cfbbea7fd3811c65453365df288243d2.svg";